import { render, staticRenderFns } from "./CareProfessionals.vue?vue&type=template&id=3a2fdfe4"
import script from "./CareProfessionals.vue?vue&type=script&lang=js"
export * from "./CareProfessionals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports